const state = {
	loading: []
}

const getters = {
	isLoading: state => !!state.loading.length,
	loadingStatus: state => {
		const lastLoading = state.loading[state.loading.length - 1]
		return lastLoading ? lastLoading.status : ''
	}
}

const mutations = {
	startLoading: (state, value) => {
		state.loading.push(value)
	},

	finishLoading: (state, value) => {
		const loadingIndex = state.loading.indexOf(value)
		state.loading.splice(loadingIndex, 1)
	}
}
const actions = {}

export default {
	state,
	getters,
	mutations,
	actions
}
